import React, { useContext } from "react";
import { connect } from "react-redux";
import { Table } from "../view/Table";
import UsersTableRow from "./UsersTableRow";
import UsersTableRowSkeleton from "./UsersTableRowSkeleton";
import { debug } from "../utils";
import { TableContext } from "../index";


function UsersTable({ users }) {

    const { config } = useContext(TableContext);

    // Client-side filtering based on searchTerm from context
    const filteredResults = users.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const username = (item.username || '').toLowerCase();
        const firstName = (item.firstName || '').toLowerCase();
        const lastName = (item.lastName || '').toLowerCase();
        const type = (item.type || '').toLowerCase();
        const role = (item.userRole?.name || '').toLowerCase();

        return username.includes(term) || firstName.includes(term) || lastName.includes(term) || type.includes(term) || role.includes(term);
    });

    const headers = [
        { name: 'Username' },
        { name: 'First Name' },
        { name: 'Last Name' },
        { name: 'User Type' },
        { name: 'Role' },
        { name: 'Assigned Groups', width: '22%' },
    ]

    return (
        <>
            <Table headers={headers} elements={filteredResults} className="mt-4">
                {config.isLoading ? (
                    Array.from(new Array(5)).map((_, index) => (
                        <UsersTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredResults.map((user, index) => <UsersTableRow key={index} data={user} index={index} />)
                )}
            </Table>
            {!config.isLoading && filteredResults.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("UsersTable mapStateToProps", state);
    const authPage = state.authPage;
    return {
        users: authPage.users || []
    };
}

export default connect(mapStateToProps)(UsersTable);
